module.exports = require("http");


/*****************
 ** WEBPACK FOOTER
 ** external "http"
 ** module id = 513
 ** module chunks = 0
 **/